import aGreenerClean from "./a-greener-clean.jsx";
import issaCleaningShow from "./issa-cleaning-show.jsx";
import yourPremierPartner from "./your-premier-partner.jsx";
import laundryRevolution from "./laundry-revolution.jsx";
import riseOfDetergentSheets from "./rise-of-detergent-sheets.jsx";
import kleanLeafExpansion from "./klean-leaf-expansion.jsx";
import naturalProductsExpoWest2024 from "./natural-products-expo-west-2024.jsx";
import laundryDetergentSheetsVsLiquid from "./laundry-detergent-sheets-vs-liquid.jsx";
import howToUseLaundryDetergentSheets from "./how-to-use-laundry-detergent-sheets.jsx";
import yearOfInnovationInLaundryCare from "./year-of-innovation-in-laundry-care.jsx";
import naturalProductsExpoWest2025Recap from "./natural-products-expo-west-2025-recap.jsx";
import whyRefillShopsLoveBulkUnpackedDetergentSheets from "./why-refill-shops-love-bulk-unpacked-detergent-sheets.jsx";
import pvaControversyKleanLeafInnovation from "./pva-controversy-klean-leaf-innovation.jsx";
import kleanLeafCleanShowOrlando2025 from "./klean-leaf-clean-show-orlando-2025.jsx";
import kleanLeafPvaFreeLaundrySheetsAreHere from "./klean-leaf-pva-free-laundry-sheets-are-here.jsx";
import laundryDetergentSheetsSmartBusinessOpportunity from "./laundry-detergent-sheets-smart-business-opportunity.jsx";
import howToStartPrivateLabelLaundryDetergentSheetsBrand from "./how-to-start-private-label-laundry-detergent-sheets-brand.jsx";
import howLaundryDetergentSheetsAreMadeCountryOriginTransparency from "./how-laundry-detergent-sheets-are-made-country-origin-transparency.jsx";
import doLaundryDetergentSheetsReallyCleanFormulaImprovements from "./do-laundry-detergent-sheets-really-clean-formula-improvements.jsx";
import launchLaundryDetergentSheetsProductLineKleanLeaf from "./launch-laundry-detergent-sheets-product-line-klean-leaf.jsx";
import whatElseKleanLeafManufactures from "./what-else-klean-leaf-manufactures.jsx";
import laundryDetergentSheetsPackagingLabelRequirements from "./laundry-detergent-sheets-packaging-label-requirements.jsx";
import privateLabelLaundryDetergentSheetsPackagingProcess from "./private-label-laundry-detergent-sheets-packaging-process.jsx";
import longLastingFragranceLaundryDetergentSheets from "./long-lasting-fragrance-laundry-detergent-sheets.jsx";
import areAluminumBottlesMoreEcoFriendlyThanPlastic from "./are-aluminum-bottles-more-eco-friendly-than-plastic.jsx";
import bestLaundryDetergentSheetManufacturers2026 from "./best-laundry-detergent-sheet-manufacturers-2026.jsx";
import customFragranceLaundryDetergentSheets from "./custom-fragrance-laundry-detergent-sheets.jsx";
import customStainRemoverPens from "./custom-stain-remover-pens.jsx";

const posts = [
  aGreenerClean,
  issaCleaningShow,
  yourPremierPartner,
  laundryRevolution,
  riseOfDetergentSheets,
  kleanLeafExpansion,
  naturalProductsExpoWest2024,
  laundryDetergentSheetsVsLiquid,
  howToUseLaundryDetergentSheets,
  yearOfInnovationInLaundryCare,
  naturalProductsExpoWest2025Recap,
  whyRefillShopsLoveBulkUnpackedDetergentSheets,
  pvaControversyKleanLeafInnovation,
  kleanLeafCleanShowOrlando2025,
  kleanLeafPvaFreeLaundrySheetsAreHere,
  laundryDetergentSheetsSmartBusinessOpportunity,
  howToStartPrivateLabelLaundryDetergentSheetsBrand,
  howLaundryDetergentSheetsAreMadeCountryOriginTransparency,
  doLaundryDetergentSheetsReallyCleanFormulaImprovements,
  launchLaundryDetergentSheetsProductLineKleanLeaf,
  whatElseKleanLeafManufactures,
  laundryDetergentSheetsPackagingLabelRequirements,
  privateLabelLaundryDetergentSheetsPackagingProcess,
  longLastingFragranceLaundryDetergentSheets,
  areAluminumBottlesMoreEcoFriendlyThanPlastic,
  bestLaundryDetergentSheetManufacturers2026,
  customFragranceLaundryDetergentSheets,
  customStainRemoverPens,
];

export default posts;
